import { KYMW1312Model } from '../kymw1312.model';
import { KYMW1312GetSetPlanGoodsInfoModel } from '../vo/kymw1312-get-set-plan-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * セット企画画面　企画商品情報を取得するサービス
 *
 * @export GetSetPlanGoodsInfoService
 * @class GetSetPlanGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSetPlanGoodsInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1312Model}
   * @memberof GetSetPlanGoodsInfoService
   */
  private model: KYMW1312Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1312GetSetPlanGoodsInfoModel}
   * @memberof GetSetPlanGoodsInfoService
   */
  private vo: KYMW1312GetSetPlanGoodsInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSetPlanGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetPlanGoodsInfo: {
          condition: {
            OrderCode: this.vo.orderCode,
            AccessDiv: this.vo.accessDiv
          },
          combination: this.vo.pCodeList.map(pcode => {
            return {
              condition: {
                PCode: pcode
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSetPlanGoodsInfoService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1312Model>model;
    this.vo = vo;
    this.send('getSetPlanGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSetPlanGoodsInfoService
   */
  success(data: any): void {
    this.model.updateSetPlanGoodsInfo(data);

    this.model.KYMW1312Component.setEnabledBtn();

    this.model.KYMW1312Component.txt_ApprovedNum.nativeElement.focus();
  }
}
